(function () {
  'use strict';

  var wrap = document.getElementById('sw-wrap');
  if (!wrap) return;

  var prizes = window.SW_PRIZES || [];
  if (!prizes.length) return;

  var customerId   = wrap.dataset.customerId || '';
  var customerEmail = wrap.dataset.customerEmail || '';
  var isLoggedIn   = !!(customerId && customerId !== '' && customerId !== 'false');
  var eventStart   = wrap.dataset.eventStart || '';
  var eventEnd     = wrap.dataset.eventEnd || '';
  var sheetsUrl    = wrap.dataset.sheetsUrl || '';
  var loginUrl     = wrap.dataset.loginUrl || '/account/login';
  var registerUrl  = wrap.dataset.registerUrl || '/account/register';
  var currentPath  = wrap.dataset.currentPath || '';

  var startBtn     = document.getElementById('sw-start-btn');
  var machine      = document.getElementById('sw-machine');
  var ballWrap     = document.getElementById('sw-ball-wrap');
  var ballSpin     = document.getElementById('sw-ball-spin');
  var ball         = document.getElementById('sw-ball');
  var tapHint      = document.getElementById('sw-tap-hint');
  var resultOverlay = document.getElementById('sw-result');
  var prizeName    = document.getElementById('sw-prize-name');
  var couponBtn    = document.getElementById('sw-coupon-btn');
  var ballText     = document.getElementById('sw-ball-text');
  var loginOverlay = document.getElementById('sw-login-overlay');
  var loginBtn     = document.getElementById('sw-login-btn');
  var registerBtn  = document.getElementById('sw-register-btn');
  var doneSection  = document.getElementById('sw-done');
  var doneCouponBtn = document.getElementById('sw-done-coupon-btn');
  var periodSection = document.getElementById('sw-period');
  var periodDesc   = document.getElementById('sw-period-desc');
  var loading      = document.getElementById('sw-loading');

  var used = false;

  function isEventActive() {
    if (!eventStart || !eventEnd) return true;
    var now   = new Date();
    var start = new Date(eventStart + 'T00:00:00');
    var end   = new Date(eventEnd + 'T23:59:59');
    return now >= start && now <= end;
  }

  function pickPrize() {
    var total = prizes.reduce(function (s, p) { return s + (p.weight || 1); }, 0);
    var r = Math.random() * total, cum = 0;
    for (var i = 0; i < prizes.length; i++) {
      cum += prizes[i].weight || 1;
      if (r <= cum) return prizes[i];
    }
    return prizes[prizes.length - 1];
  }

  function showLoading()  { if (loading) loading.style.display = 'flex'; }
  function hideLoading()  { if (loading) loading.style.display = 'none'; }

  function checkParticipation(cb) {
    if (!sheetsUrl || sheetsUrl === 'YOUR_APPS_SCRIPT_URL_HERE') { cb(false, null); return; }
    var params = new URLSearchParams({
      action: 'check',
      customerId: customerId,
      eventKey: eventStart + '_' + eventEnd
    });
    fetch(sheetsUrl + '?' + params.toString())
      .then(function (r) { return r.json(); })
      .then(function (d) { cb(d.participated, d.prize || null); })
      .catch(function () { cb(false, null); });
  }

  function saveParticipation(prize, cb) {
    if (!sheetsUrl || sheetsUrl === 'YOUR_APPS_SCRIPT_URL_HERE') { cb(true); return; }
    fetch(sheetsUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'save',
        customerId: customerId,
        customerEmail: customerEmail,
        prizeName: prize.name,
        prizeUrl: prize.url,
        eventKey: eventStart + '_' + eventEnd,
        timestamp: new Date().toISOString()
      })
    }).then(function () { cb(true); }).catch(function () { cb(true); });
  }

  function showResult(prize) {
    prizeName.textContent = prize.name;
    couponBtn.href = prize.url || '#';
    resultOverlay.classList.add('sw-show');
  }

  function showAlreadyDone(prize) {
    if (startBtn) startBtn.parentElement.style.display = 'none';
    document.getElementById('sw-game-area').style.display = 'none';
    doneSection.style.display = 'block';
    if (prize && doneCouponBtn) {
      doneCouponBtn.href = prize.url || '#';
      document.getElementById('sw-done-prize').textContent = prize.name;
    }
  }

  function showPeriodError() {
    document.getElementById('sw-game-area').style.display = 'none';
    document.getElementById('sw-actions').style.display = 'none';
    periodSection.style.display = 'block';
    if (periodDesc) {
      periodDesc.textContent = eventStart && eventEnd
        ? '이벤트 기간: ' + eventStart + ' ~ ' + eventEnd
        : '현재 진행 중인 이벤트가 없습니다';
    }
  }

  function runSpin(winner) {
    used = true;
    if (startBtn) startBtn.disabled = true;
    ballText.textContent = winner.name;

    machine.classList.add('sw-vibrate');

    setTimeout(function () {
      machine.classList.remove('sw-vibrate');
      machine.classList.add('sw-shake');

      setTimeout(function () {
        machine.classList.remove('sw-shake');
        ballWrap.classList.add('sw-rolling');

        setTimeout(function () {
          ballSpin.classList.add('sw-spinning');
          tapHint.classList.add('sw-show');

          ballWrap.addEventListener('click', function onFlip() {
            ballWrap.removeEventListener('click', onFlip);
            ballSpin.classList.remove('sw-spinning');
            tapHint.style.opacity = '0';

            setTimeout(function () {
              ball.classList.add('sw-flipped');
              showLoading();
              saveParticipation(winner, function () {
                hideLoading();
                setTimeout(function () { showResult(winner); }, 500);
              });
            }, 80);
          });
        }, 400);
      }, 650);
    }, 1500);
  }

  function init() {
    if (!isEventActive()) { showPeriodError(); return; }

    if (!isLoggedIn) {
      hideLoading();
      return;
    }

    showLoading();
    checkParticipation(function (participated, prize) {
      hideLoading();
      if (participated) { showAlreadyDone(prize); return; }
    });
  }

  if (startBtn) {
    startBtn.addEventListener('click', function () {
      if (used) return;
      if (!isLoggedIn) {
        loginOverlay.classList.add('sw-show');
        return;
      }
      var winner = pickPrize();
      runSpin(winner);
    });
  }

  if (loginBtn) {
    loginBtn.href = loginUrl + '?return_url=' + encodeURIComponent(currentPath);
  }
  if (registerBtn) {
    registerBtn.href = registerUrl + '?return_url=' + encodeURIComponent(currentPath);
  }

  init();
  hideLoading();
})();
